import CityPageMosquiteras from "../components/CityPageMosquiteras";

export default function Page() {
  return (
    <CityPageMosquiteras
      name="Mijas"
      slug="mijas"
      cp="29649, 29650, 29651"
      poblacion={94320}
      zonaGeo="Costa del Sol Occidental"
      lat={36.5953}
      lng={-4.6371}
      zonas={["Mijas Costa", "La Cala de Mijas", "Calahonda", "Riviera del Sol"]}
      landmarks={["Mijas Pueblo", "Hipódromo Costa del Sol"]}
      municipiosLimitrofes={["Fuengirola", "Benalmádena", "Marbella"]}
      festivalLocal="Feria de Mijas (septiembre)"
      contextoTipologico="Urbanizaciones modernas costeras con jardines, casas tradicionales en el pueblo, gran comunidad expat que valora protección contra insectos."
      isCoreZone={true}
    />
  );
}